module.exports = __webpack_public_path__ + "static/media/facebook.853d9f93.svg";